"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var constants_1 = require("./constants");
exports.CLASS_NAME = constants_1.BASE_CLASS_NAME + "__title";
exports.propertyClassNames = {
    LARGE: exports.CLASS_NAME + "--large",
};
/**
 * Primary section title component
 */
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function () {
        return exports.CLASS_NAME;
    };
    Meta.prototype.renderClassValues = function () {
        return [(_a = {},
                _a[exports.propertyClassNames.LARGE] = this.props.large,
                _a)];
        var _a;
    };
    Meta.defaultProps = {
        large: false,
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var Title = (function (_super) {
    __extends(Title, _super);
    function Title() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Title.prototype.getMetaComponent = function () {
        return Meta;
    };
    Title.prototype.getMetaPropNames = function () {
        return [
            "className",
            "large",
        ];
    };
    Title.prototype.getChildComponent = function () {
        return "h1";
    };
    Title.Meta = Meta;
    return Title;
}(base_1.DefaultComponentBase));
exports.default = Title;
//# sourceMappingURL=Title.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/card/lib/Title.js
// module id = ./node_modules/@react-mdc/card/lib/Title.js
// module chunks = 1